import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
const links = [
  { label: "About", path: "/about" },
  { label: "Our Work", path: "/services" },
  { label: "Academy", path: "/trading-academy" },
  { label: "Advisory", path: "/advisory" },
  { label: "Partnerships", path: "/partnerships" },
  { label: "Insights", path: "/insights" },
];
export default function Navbar() {
  const [open, setOpen] = useState(false);
  const toggle = useRef<HTMLButtonElement>(null);
  const { pathname } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  useEffect(() => {
    const close = (e: KeyboardEvent) => {
      if (e.key === "Escape" && open) {
        setOpen(false);
        toggle.current?.focus();
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [open]);
  return (
    <header className="site-header">
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <div className="site-nav shell">
        <Link
          to="/"
          className="brand"
          aria-label="Harambee Global Ventures home"
        >
          <img src="/assets/brand/logo.png" width="64" height="52" alt="" />
          <span>
            HARAMBEE<small>GLOBAL VENTURES</small>
          </span>
        </Link>
        <nav className="desktop-nav" aria-label="Main navigation">
          {links.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              aria-current={pathname === l.path ? "page" : undefined}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <Link
          to="/contact#contact-form"
          className="button button-green desktop-contact"
        >
          Get in Touch <span aria-hidden="true">↗</span>
        </Link>
        <button
          ref={toggle}
          className="menu-toggle"
          aria-label={open ? "Close navigation" : "Open navigation"}
          aria-expanded={open}
          aria-controls="mobile-navigation"
          onClick={() => setOpen(!open)}
        >
          {open ? "Close ×" : "Menu ☰"}
        </button>
      </div>
      {open && (
        <nav
          id="mobile-navigation"
          className="mobile-nav shell"
          aria-label="Mobile navigation"
        >
          {[
            ...links,
            { label: "Contact", path: "/contact" },
          ].map((l) => (
            <Link
              key={l.path}
              to={l.path}
              aria-current={pathname === l.path ? "page" : undefined}
              onClick={() => setOpen(false)}
            >
              {l.label}
              <span aria-hidden="true">↗</span>
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}
